import dayjs from 'dayjs'
import { localizedNeedLoginPath } from '~/utils/common'

export function useLogin() {
  const { $request } = useNuxtApp()
  const visible = useState('login-visible', () => false)
  const isReload = useState('is-$requesteload', () => false)
  const route = useRoute()
  const user = useUser()
  function toggleDialog(val: boolean, reload = false, trackName?: 'loginxia' | 'loginshang') {
    visible.value = val
    isReload.value = reload
    const { isFromFb } = useFbqPixel()
    if (window.fbq && trackName && isFromFb.value) {
      window.fbq('trackCustom', trackName, { page: 'report_detail', action: 'login_click' })
    }
  }
  const isLogin = computed(() => !!user.value.isLogin)
  const userRole = computed(() => user.value?.info?.privilegesV2?.find((item: any) => item.resource === user.value?.info?.userRole) || { resource: user.value?.info?.userRole })
  // 判断userRole的privilegeValue时间戳是否过期
  const userRoleExpired = computed(() => {
    const moduleInfo = userRole.value
    return moduleInfo?.privilegeValue && dayjs().isAfter(dayjs(user.value?.info?.expireInSecond * 1000))
  })
  // 是否是子账号
  const isSubAccount = computed(() => {
    return user.value?.info?.parentUserId > 0
  })
  const isExpired = computed(() => {
    return !isLogin.value ? false : !user.value.info?.privilegesV2?.length || userRoleExpired.value || user.value?.info?.userRole === 3
  })
  watch(() => visible.value, (val) => {
    if (!val && !isLogin.value) {
      // eslint-disable-next-line ts/no-unused-expressions
      isReload.value && location.reload()
    }
  })
  async function refetchUserInfo() {
    await useRequest<Api.User.Info>('/user/info', { key: 'userInfo' })
  }
  function setUserInfo(data?: Api.User.Info) {
    const user = useUser()
    user.value.info = data ?? {
      id: 0,
      name: 'v',
      phone: '13611111111',
      createTime: '1704038400000',
      isNewUser: 0,
      userRole: 3,
      permissions: [],
      privileges: [],
      accessToken: '',
    } as unknown as Api.User.Info
    user.value.isLogin = user.value.info?.id > 0
  }
  const isExpiredOrUnLogin = computed(() => !isLogin.value || isExpired.value)
  async function logout() {
    try {
      await $request('https://gloda.authing.cn/oidc/session/end', {
        isCustomError: true,
      })
      await $request<any>('/user/logout')
      await refetchUserInfo()
      const localePath = useLocalePath()
      if (localizedNeedLoginPath().includes(route.path)) {
        navigateTo(localePath('/analysis/products'))
      }
    }
    catch (e) {
      console.error(e)
    }
  }

  return {
    visible,
    isLogin,
    isExpired,
    isExpiredOrUnLogin,
    isSubAccount,
    userRole,
    setUserInfo,
    logout,
    toggleDialog,
    refetchUserInfo,
  }
}
